// When a break (an ad) is due before an episode. Nothing here touches the page, so the rules can be tested on their own.
//
// The rules, all of which the site can change in the dashboard:
//  - the first `free` episodes of anything are never interrupted (a viewer who has only just started is left alone),
//  - after those, one break before every `every`-th episode: with 2 free and every 3 that is episodes 3, 6, 9, 12 ...,
//  - an episode that has already had its break in this visit never gets another, so replaying it, reloading, or coming back to it
//    is left alone,
//  - at least `gapMs` between two breaks, and at most `cap` in one visit (0 means no limit).

export const emptyMemory = () => ({ shown: [], at: 0, count: 0 });

export function breakDue({ episode, free, every, memory, now, gapMs, cap, key }) {
  if (!every || !Number.isInteger(episode) || episode < 1) return false;
  if (episode <= free || (episode - free - 1) % every !== 0) return false;
  if (memory.shown.includes(key)) return false;
  if (cap > 0 && memory.count >= cap) return false;
  if (gapMs > 0 && now - memory.at < gapMs) return false;
  return true;
}

/** What to keep after a break was shown. Only the most recent ones are kept, so it stays small. */
export const remember = (memory, key, now) => ({ shown: [...memory.shown.slice(-199), key], at: now, count: memory.count + 1 });
